module.exports = __webpack_public_path__ + "static/media/camping-02.31ae1878.jpg";